import { Box, Container, HStack, Modal, ModalBody, ModalContent, ModalOverlay, Stack, useBreakpointValue} from "@chakra-ui/react";
import React from "react";
import { explore } from "../../../../constants/constants";
import { CopyPasteService } from "../../../../services/CopyPaste";
import InfiniteScroll from "react-infinite-scroll-component";
import Grid from "../../../../FunctionalComponents/SimpleGrid/Grid";
import ArchiveGrid from "../../../../FunctionalComponents/SimpleGrid/ArchiveGrid";
import { FilterBox } from "../../../../CommonComponents/Filter/FilterBox";
import NoMoreToLoad from "../../../../CommonComponents/NoMoreToLoad";
import { DataNotFound } from "../../../../CommonComponents/DataNotFound";
import FilterPills from "../../../../CommonComponents/Filter/FilterPills";

const IMAGE_BASE_PATH = process.env.REACT_APP_DEV_IMAGE_BASE_PATH;
const loaderImg = `${IMAGE_BASE_PATH}/ui/Chevron/loader.gif`;

function GridView({
  handleDrawer,
  masterlistType = "generic",
  fetchMoreData,
  data,
  filterPills,
  setFilterPills,
  showFilterBox,
  handleFilterClick,
  hasMore,
  setShowFilterBox,
  setApply,
  sort,
  handleCheckboxChange,
  handleSearch,
  filterOptions,
  filteroptionData,
  setFilterOptions,
  setSearchTerm,
  filterCount,
  searchTerm,
  handleReset,
  filterbuttonStyle,
  filteredResultCount,
}) {
  const isMobile = useBreakpointValue({ base: true, md: false });
  return (
    <>
      <Stack flexDirection={{base:"column",md:"row-reverse"}} marginTop={{base:"-38px!important",md:"0px!important"}}>
        <Container
          maxW="auto"
          className="songs"
          px={{ base: "0px", md: "0px" }}
          py={{base:masterlistType === "generic"? "40px":"2", md:masterlistType === "generic"? "40px":"8"}}
          position={"relative"}
        >
           <Stack flexDirection={{base:"column",md:"row"}} gap={4} justifyContent="center">
            {data && data?.length > 0 ? (
              <Stack
                onCopy={(e) =>
                  CopyPasteService(e, `${window.location.href}/0/1`)
                }
                marginRight={{ base: "0px", md: "30px" }}
                alignItems={"flex-start"}
              >
          <Box bg="white" width={"100%"} position={"sticky"} top={masterlistType === "search" ? "0px" : "105px"}>
          {((filterPills &&  filterPills?.search) || filterCount > 0) && 
          <FilterPills
          filters={filterPills}
          setFilterOptions={setFilterOptions}
          setApply={setApply}
          setSearchTerm={setSearchTerm}
          setFilterPills={setFilterPills}
          filteredResultCount={filteredResultCount}
          />
          }</Box>
                <InfiniteScroll
                  dataLength={data?.length}
                  next={fetchMoreData}
                  hasMore={hasMore}
                  loader={
                    <Box textAlign="center" display={"flex"} justifyContent={"center"}>
                      <Stack marginTop={"20px"}>
                        <img
                          src={loaderImg}
                          width={"100px"}
                          height={"100px"}
                          alt="Loading"
                        />
                      </Stack>
                    </Box>
                  }
                  endMessage={<NoMoreToLoad />}
                >
                  <Grid
                    data={data}
                    handleDrawer={handleDrawer}
                    spacing={{base:'10px',md:'24px'}}
                    columns={{ base: 2, md: 3, lg: 4, xl: 4 }}
                    component={ArchiveGrid}
                    border={true}
                  />
                </InfiniteScroll>
              </Stack>
            ) : (
              <>
              <Stack
              onCopy={(e) =>
                CopyPasteService(e, `${window.location.href}/0/1`)
              }
              marginRight={{ base: "0px", md: "30px" }}
              alignItems={"flex-start"}
              width={"100%"}
            >
          <Box bg="white" width={"100%"} position={"sticky"} top={"105px"}>
          {((filterPills &&  filterPills?.search) || filterCount > 0) && 
                 <FilterPills
                 filters={filterPills}
                 setFilterOptions={setFilterOptions}
                 setApply={setApply}
                 setSearchTerm={setSearchTerm}
                 setFilterPills={setFilterPills}
                 filteredResultCount={filteredResultCount}
                 />
            }
            </Box>
                  <HStack width={"100%"} justifyContent={"center"}>
                   <DataNotFound />
  
                  </HStack>
                  </Stack>
              </>
            )}
             <HStack
      marginLeft={"4"}
      marginRight={"0px!important"}
      className="mt-0"
      alignItems={"flex-start"}
      pos={masterlistType === "generic" && "relative"}
      right={masterlistType === "generic" && "-5px"}
    >
      {showFilterBox && (
        isMobile ? (
          <Modal isOpen={showFilterBox} onClose={() => setShowFilterBox(false)}     returnFocusOnClose={false}>
            <ModalOverlay />
            <ModalContent>
              <ModalBody px="15px">
                <FilterBox
                 setShowFilterBox={setShowFilterBox}
                 setApply={setApply}
                 explore={explore}
                 sort={sort}
                 handleCheckboxChange={handleCheckboxChange}
                 handleSearch={handleSearch}
                 filterOptions={filterOptions}
                 filteroptionData={filteroptionData}
                 setFilterOptions={setFilterOptions}
                 setSearchTerm={setSearchTerm}
                 filterCount={filterCount}
                 searchTerm={searchTerm}
                 handleReset={handleReset}
                 className="box-filter-film2"
                />
              </ModalBody>
            </ModalContent>
          </Modal>
        ) : (
          <FilterBox
            setShowFilterBox={setShowFilterBox}
            setApply={setApply}
            explore={explore}
            sort={sort}
            handleCheckboxChange={handleCheckboxChange}
            handleSearch={handleSearch}
            filterOptions={filterOptions}
            filteroptionData={filteroptionData}
            setFilterOptions={setFilterOptions}
            setSearchTerm={setSearchTerm}
            filterCount={filterCount}
            searchTerm={searchTerm}
            handleReset={handleReset}
            className={masterlistType === "search" || masterlistType !== "research-categories" ? "box-filter-film" : "box-filter-film5"}
          />
        )
      )}
    </HStack>
          </Stack>
        </Container>
      </Stack>
    </>
  );
}
export default GridView;

